import { View, ActivityIndicator, Pressable } from "react-native"
import { SafeAreaView } from "react-native-safe-area-context"
import { Link } from "expo-router"
import { trpc } from "utils/trpc"
import { Header } from "components/Header"
import MIcon from "@react-native-vector-icons/material-design-icons"
import { ar } from "i18n/ar"
import { Text, TextInput } from "components/core"
import { useState, useDeferredValue } from "react"
import { useDebounce } from "use-debounce"
import { List } from "@src/components/list"
import { sharedStyles } from "@src/utils"

export default function SuppliersScreen() {
  const [search, setSearch] = useState("")
  const [debouncedSearch] = useDebounce(search, 500)
  const deferredSearch = useDeferredValue(debouncedSearch)

  const _suppliers = trpc.suppliers.list.useInfiniteQuery({ search: deferredSearch.trim() }, { getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined })

  const suppliers = _suppliers.data?.pages.flatMap((page) => page.items) ?? []

  const header = (
    <Header
      className="mb-1"
      title={ar.suppliers}
      right={
        <Link href="/dashboard/supplier/create" asChild>
          <Pressable className="h-full px-2 justify-center active:opacity-70">
            <MIcon name="plus" size={24} color="blue" />
          </Pressable>
        </Link>
      }
    />
  )

  return (
    <>
      {header}
      <List
        className="flex-1"
        data={suppliers}
        contentContainerStyle={sharedStyles.contentContainer}
        onRefresh={_suppliers.refetch}
        onEndReached={() => {
          if (_suppliers.hasNextPage && !_suppliers.isFetchingNextPage) _suppliers.fetchNextPage()
        }}
        onEndReachedThreshold={0.5}
        ListHeaderComponent={
          <View className="w-full max-w-content mx-auto pt-1 pb-1 px-2">
            <TextInput placeholder={ar.searchSuppliers} value={search} onChangeText={setSearch} />
          </View>
        }
        ListEmptyComponent={_suppliers.isLoading ? <ActivityIndicator className="py-8" /> : <Text className="text-gray-500 text-center py-8">{ar.noSupplier}</Text>}
        renderItem={({ item: supplier }) => (
          <Link href={`/dashboard/supplier/${supplier.id}`} asChild>
            <Pressable className="bg-white border border-gray-100 rounded-lg mx-2 mb-2 active:bg-gray-50">
              <View className="p-4 gap-1">
                <Text className="text-lg font-semibold text-gray-800" numberOfLines={1}>
                  #{supplier.id} {supplier.name}
                </Text>
                {supplier.phones.length > 0 ? (
                  <View className="flex-row items-center gap-1.5">
                    <MIcon name="phone" size={16} color="#6B7280" />
                    <Text className="text-sm text-gray-500" numberOfLines={1}>
                      {supplier.phones.join(" · ")}
                    </Text>
                  </View>
                ) : null}
                {supplier.brands.length > 0 ? (
                  <View className="flex-row items-center gap-1.5">
                    <MIcon name="tag" size={16} color="#6B7280" />
                    <Text className="text-sm text-gray-500" numberOfLines={1}>
                      {supplier.brands.map((brand) => brand.name).join(" · ")}
                    </Text>
                  </View>
                ) : null}
              </View>
            </Pressable>
          </Link>
        )}
        ListFooterComponent={
          <>
            {_suppliers.isFetchingNextPage && <ActivityIndicator className="py-4" />}
            <SafeAreaView edges={["bottom"]} />
          </>
        }
      />
    </>
  )
}
